export default __webpack_public_path__ + "static/media/gazpacho_thumb.ffd9aa7c.jpg";